<template>
  <div :class="['badge', `mode-${props.mode}`]">
    <div class="badge__content">
      <span class="badge__label">{{ props.label }}:</span>

      <template v-if="props.icon">
        <img :src="props.icon" alt="Icon" class="badge__icon" />
      </template>

      <span :class="['badge__value', `value-color-${props.valueColor}`]">
        {{ props.value }}
      </span>
    </div>
  </div>
</template>

<script setup lang="ts">
export interface BadgeProps {
  label: string;
  value: string | number;
  icon?: string;
  mode?: 'default' | 'primary';
  valueColor?: 'default' | 'accent';
}

const props = withDefaults(defineProps<BadgeProps>(), {
  icon: undefined,
  mode: 'default',
  valueColor: 'default'
});
</script>

<style lang="scss" scoped>
.badge {
  display: inline-flex;
  padding: 6px 8px;
  border-radius: 12px;
  background-color: #081b25;
  border: 1px solid #1e353e;

  font-family: Eczar;
  font-weight: 500;
  font-size: 16px;
  line-height: 1;
  color: #fff;

  &__content {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 4px;
  }

  &__label {
    white-space: nowrap;
  }

  &__icon {
    width: 24px;
    height: 24px;
    object-fit: contain;
  }

  &.mode-primary {
    background: linear-gradient(180deg, #0083ad 0%, #00354f 100%);
  }

  &__value {
    &.value-color-default {
      color: #ffffff;
    }

    &.value-color-accent {
      color: #49ddaa;
    }
  }
}
</style>
